import { forNamespace } from 'common/lib/util/i18n';
import * as React from 'react';
import styles from './closed-boards-dialog.less';

const format = forNamespace('closed boards dialog');

interface FreeTeamProps {
  name: string;
  upgradeUrl: string;
}

interface FreeTeamsOutOfSpacePopoverProps {
  teams: FreeTeamProps[];
}

const FreeTeamOutOfSpace = (props: FreeTeamProps) => (
  <tr className={styles.row}>
    <td className={styles.name}>{props.name}</td>
    <td className={styles.link}>
      <a href={props.upgradeUrl}>{format('upgrade team')}</a>
    </td>
  </tr>
);

const FreeTeamsOutOfSpacePopover = (props: FreeTeamsOutOfSpacePopoverProps) => {
  return (
    <table className={styles.cbdtlContainer}>
      <tbody>
        {props.teams.map((team) => (
          <FreeTeamOutOfSpace key={team.upgradeUrl} {...team} />
        ))}
      </tbody>
    </table>
  );
};

export default FreeTeamsOutOfSpacePopover;



// WEBPACK FOOTER //
// ./app/common/components/closed-boards-dialog/free-teams-out-of-space-popover.tsx